
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";
import IBlock3Address from "@/module/main/model/applicationForm/IBlock3Address";
import HcAddress from "@/module/main/components/HcAddress.vue";

@Component({
    components: {
        HcAddress,
    }
})
export default class Block3Address extends HcPageModel {
    @Prop({type: Object}) public value!: IBlock3Address;

    protected pageName: string = "block3-address";

    private isContactSameAsPermanent: object[] = [
        {
            label: this.$localize("app-common-yes"),
            value: "true"
        },
        {
            label: this.$localize("app-common-no"),
            value: "false"
        }
    ];

    private get showPermanentAddress(): boolean {
        return this.value.contactSameAsPermanent === "false";
    }
}
